module.exports = __webpack_public_path__ + "img/zuobiao.adcf8ee4.png";